import React from 'react';
import { FilterBar } from '../filters/FilterBar';
import { AddableCardGrid } from '../cards/AddableCardGrid';
import { PokemonCard, FilterState } from '../../types/pokemon';
import { Loader2 } from 'lucide-react';
import { Button } from 'antd';
import { useI18n } from '../../contexts/I18nContext';

// Importez les types PackInfo et SetInfo
interface PackInfo {
  name: string;
  img: string | null;
}

interface SetInfo {
  name: string;
  display_name: string;
  img: string | null;
}

interface DeckCardSelectorProps {
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
  cards: PokemonCard[];
  loading: boolean;
  selectedCards: Map<number, number>;
  onUpdateQuantity: (cardId: number, quantity: number) => void;
  totalCards: number;
  filterOptions: {
    packs: PackInfo[];
    rarities: string[];
    sets: SetInfo[];
    types: string[];
    energies: string[];
  };
  hasMore?: boolean;
  isLoadingMore?: boolean;
  onLoadMore?: () => void;
  totalCount?: number;
}

export function DeckCardSelector({
  filters,
  onFilterChange,
  cards,
  loading,
  selectedCards,
  onUpdateQuantity,
  totalCards,
  filterOptions,
  hasMore = false,
  isLoadingMore = false,
  onLoadMore,
  totalCount = 0
}: DeckCardSelectorProps) {
  const { t } = useI18n();
  
  return (
    <div className="space-y-4">
      <FilterBar
        filters={filters}
        onFilterChange={onFilterChange}
        packs={filterOptions.packs}
        rarities={filterOptions.rarities}
        sets={filterOptions.sets}
        types={filterOptions.types}
        energies={filterOptions.energies}
        showMissingToggle={false}
      />

      {loading && !isLoadingMore ? (
        <div className="flex justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
        </div>
      ) : (
        <>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-500">
              {t(cards.length === 1 ? 'card_selector.showing_cards_one' : 'card_selector.showing_cards_other', { 
                displayed: cards.length, 
                total: totalCount 
              })}
            </span>
          </div>

          <AddableCardGrid
            cards={cards}
            loading={loading}
            selectedCards={selectedCards}
            onUpdateQuantity={onUpdateQuantity}
            maxQuantityPerCard={2}
            totalSelectedCards={totalCards}
          />

          {hasMore && (
            <div className="flex justify-center mt-4">
              <Button
                onClick={onLoadMore}
                loading={isLoadingMore}
                className="w-full sm:w-auto"
              >
                {t('card_selector.load_more')}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}